import { styled } from '@mui/material/styles';

export const StyledWrapper = styled('div')(({ theme }) => {
  return {
    '& ul, ol': {
      padding: 0,
      margin: 0,
      listStyleType: 'none',
    },
    '& li': {
      listStyleType: 'none',
      margin: 0,
      '&::before': {
        content: '"\u2713"',
        fontSize: '14px',
        color: theme.palette.customSuccess.mainCustom,
        marginRight: '6px',
      },
    },
  };
});
